import ProfilePostsSummary from "./ProfilePostsSummary";
export default ProfilePostsSummary;
